import { z } from '../zod.js';
import { ObjectIdStringValidationSchema } from '../shared/ObjectId';

export const GetCustomerInputValidationSchema = z.object({
  customerId: ObjectIdStringValidationSchema.meta({
    description:
      'The ID of the customer to retrieve. Use `list_customers` first if you need to discover the customer ID by name or email.',
  }),
});
